
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(10|365|385)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
